import { Icons } from '@/assets/icons/icons';
import { XStack } from '@/components/ui/layout/layout';
import { ProgressBar } from '@/components/ui/ProgressBar';
import type { InstallStep } from '@/features/electron-api/features/CodingAgentsAPI';

import type { SetupProgress } from './coding-agents.store';

const INSTALL_STEP_TEXT: Record<InstallStep, string> = {
  downloading: 'Downloading the installer',
  installing: 'Installing, which can take a few minutes',
  checking: 'Checking the install',
};

/** The lines under an agent's name while it installs or signs in */
export const SetupProgressView = ({ progress }: { progress: SetupProgress }) =>
  progress.activity === 'signing-in' ? (
    <XStack
      role="status"
      className="items-center gap-1.5 text-xs text-foreground-muted"
    >
      <Icons.loader className="size-3 shrink-0 animate-spin" />
      Finish signing in in your browser
    </XStack>
  ) : (
    <>
      <p role="status" className="text-xs text-foreground-muted">
        {progress.step
          ? INSTALL_STEP_TEXT[progress.step]
          : 'Starting the install'}
      </p>
      <ProgressBar label="Install progress" className="mt-1" />
    </>
  );
